import ApplicationPage from 'components/pagesComponents/ApplicationPage';

export default ApplicationPage;
